import AOS from 'aos';
import "./constants/polyfills";
import { _throttle, canUseWebP } from './functions/utils';

import {
  HANDLERS,
  INSTANCES
} from './constants/globals';

import HeaderHandler from './handlers/HeaderHandler';
import LogoutHandler from './handlers/LogoutHandler';
import JargonBusterHandler from './handlers/JargonBusterHandler';
import InsightEntryHandler from './handlers/InsightEntryHandler';
import CollapseHandler from './handlers/CollapseHandler';
import FAQHandler from './handlers/FAQHandler';
import MailChimpFormHandler from './handlers/MailChimpFormHandler';
import PageLoaderHandler from './handlers/PageLoaderHandler';
import ManagerPageHandler from './handlers/ManagerPageHandler';
import TimelineHandler from './handlers/TimelineHandler';
import CatNavHandler from './handlers/CatNavHandler';
import VideoHandler from './handlers/VideoHandler';
import SelectHandler from "./handlers/SelectHandler";
import DownArrowHandler from "./handlers/DownArrowHandler";
import UpArrowHandler from "./handlers/UpArrowHandler";
import InsightIndexHandler from "./handlers/InsightIndexHandler";
import FeeCalculatorHandler from './handlers/FeeCalculatorHandler';
import LogosCarouselHandler from './handlers/logosCarouselHandler';
import CustomerQuotesHandler from './handlers/CustomerQuotesHandler';
import VideosBlockSectionHandler from './handlers/VideosBlockSectionHandler';
import BenefitsHandler from './handlers/BenefitsHandler';
import FeaturedStepsHandler from './handlers/FeaturedStepsHandler';
import FeaturedStepsCarouselHandler from './handlers/FeaturedStepsCarouselHandler';
import TransferInterestFormHandler from './handlers/TransferInterestFormHandler';
import ContactTypeFormFormHandler from './handlers/ContactTypeFormHandler';
import TransferBannerHandler from './handlers/TransferBannerHandler';
import SignupTrackingHandler from './handlers/SignupTrackingHandler';
import TestimonialsCarouselHandler from './handlers/testimonialsCarouselHandler';
import ExploreOurUniverseHandler from './handlers/ExploreOurUniverseHandler';
import ProductsCarouselHandler from './handlers/productsCarouselHandler';
import HeroDownArrowHandler from './handlers/HeroDownArrowHandler';
import LiveChatHandler from './handlers/LiveChatHandler';
import RelatedInsightsHandler from './handlers/RelatedInsightsHandler';
import ManagersSwiperHandler from './handlers/ManagersSwiperHandler';
import ManagersGridHandler from './handlers/ManagersGridHandler';
import BannerHandler from './handlers/BannerHandler';
import { initializeIntercom } from '@tillitinvest/intercom-initializer';
const globalLogs = false;

let header = new HeaderHandler();
let logout = new LogoutHandler();
let jargonBusters = new JargonBusterHandler();
let catNavs = new CatNavHandler();
let insightEntries = new InsightEntryHandler();
let mailChimpForms = new MailChimpFormHandler();
let pageloader = new PageLoaderHandler();
let managerPage = new ManagerPageHandler();
let collapses = new CollapseHandler();
let faqs = new FAQHandler();
let timelines = new TimelineHandler();
let videos = new VideoHandler();
let selects = new SelectHandler();
let downArrows = new DownArrowHandler();
let upArrows = new UpArrowHandler();
let insightIndex = new InsightIndexHandler();
let feeCalculator = new FeeCalculatorHandler();
let logosCarousel = new LogosCarouselHandler();
let customerQuotes = new CustomerQuotesHandler();
let videosSection = new VideosBlockSectionHandler();
let benefitsSection = new BenefitsHandler();
let featuredSteps = new FeaturedStepsHandler();
let featuredStepsCarousel = new FeaturedStepsCarouselHandler();
let transferInterestForm = new TransferInterestFormHandler();
let contactTypeForm = new ContactTypeFormFormHandler();
let transferBanner = new TransferBannerHandler();
let signupTracking = new SignupTrackingHandler();
let testimonialsCarousel = new TestimonialsCarouselHandler();
let exploreOurUniverse = new ExploreOurUniverseHandler();
let productsCarousel = new ProductsCarouselHandler();
let heroDownArrow = new HeroDownArrowHandler();
let relatedInsights = new RelatedInsightsHandler();
let managersSwiper = new ManagersSwiperHandler();
let managersGrid = new ManagersGridHandler();
let liveChat = new LiveChatHandler();
let banner = new BannerHandler();

// AOS Init
// Added at the top not wrapped in an event as its own init already wraps it into a start event
AOS.init({
  // Global settings:
  disable: !!window.location.hash, // disable AOS if we're deeplinking to scroll issues (hopefully...) - accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
  startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
  initClassName: 'aos-init', // class applied after initialization
  animatedClassName: 'aos-animate', // class applied on animation
  useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
  disableMutationObserver: false, // disables automatic mutations' detections (advanced)
  debounceDelay: 150, // the delay on debounce used while resizing window (advanced)
  throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

  // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
  offset: 120, // offset (in px) from the original trigger point
  delay: 0, // values from 0 to 3000, with step 50ms
  duration: 1000, // values from 0 to 3000, with step 50ms
  easing: 'ease-out-cubic', // default easing for AOS animations
  once: true, // whether animation should happen only once - while scrolling down
  mirror: false, // whether elements should animate out while scrolling past them
  anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
});

// Initialise the modules you need for this project.
// This is easier to customise then initialising all of them in a loop
let initModules = () => {
  header.init();
  logout.init();
  catNavs.init();
  pageloader.init(AOS);
  jargonBusters.init();
  insightEntries.init();
  mailChimpForms.init();
  managerPage.init();
  collapses.init();
  faqs.init();
  timelines.init();
  videos.init();
  selects.init();
  downArrows.init();
  upArrows.init();
  insightIndex.init();
  feeCalculator.init();
  logosCarousel.init();
  customerQuotes.init();
  videosSection.init();
  benefitsSection.init();
  featuredSteps.init();
  featuredStepsCarousel.init();
  transferInterestForm.init();
  contactTypeForm.init();
  signupTracking.init();
  testimonialsCarousel.init();
  exploreOurUniverse.init();
  productsCarousel.init();
  heroDownArrow.init();
  relatedInsights.init();
  managersSwiper.init();
  managersGrid.init();
  liveChat.init();
}

// add modules that are not dependent on all resources to be loaded bellow
window.addEventListener('DOMContentLoaded', (event) => {
  transferBanner.init();
  banner.init();
  webpSupport();
  isPageAtTop();
});

window.onload = (event) => {
  if (sessionStorage.getItem('hasVisited') === null) sessionStorage.setItem('hasVisited', true);
  initModules();
  ready();
  scrollHelper();
};

function scrollHelper() {
  const body = document.body;
  const scrollUp = "scroll-up";
  const scrollDown = "scroll-down";
  const offset = 200;
  let lastScroll = 0;

  window.addEventListener("scroll", _throttle(() => {
    const currentScroll = window.pageYOffset;
    if (currentScroll <= offset) {
      body.classList.remove(scrollUp);
      return;
    }

    if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
      // down
      body.classList.remove(scrollUp);
      body.classList.add(scrollDown);
    } else if (
      currentScroll < lastScroll &&
      body.classList.contains(scrollDown)
    ) {
      // up
      body.classList.remove(scrollDown);
      body.classList.add(scrollUp);
    }
    lastScroll = currentScroll;
  }, 50));
}

function webpSupport() {
  const body = document.body;
  canUseWebP ? body.classList.add('webp') : body.classList.add('no-webp');
}

function isPageAtTop() {
  const body = document.body;
  if (window.scrollY > 0) {
    body.classList.add('not-top-loaded');
  }

  window.addEventListener('scroll', () => body.classList.remove('not-top-loaded'));
}

// Ready.
// --------------------------------------------------
function ready() {
  window["HANDLERS"] = HANDLERS;
  window["INSTANCES"] = INSTANCES;

  if (globalLogs) {
    console.log('ready.');
    console.log('HANDLERS:', HANDLERS);
    console.log('INSTANCES:', INSTANCES);
  }

  import('@tillitinvest/cookie-consent').then(({ renderCookieConsentDialog }) => {
    renderCookieConsentDialog(document.getElementById('cookie-consent'), null, ['/privacy'], postConsentActions);
  });
}

(function () {
  const intercomAppId = document.body.getAttribute("data-intercom-app-id");
  const appBaseUrl = document.body.getAttribute("data-app-url");

  intercomAppId && appBaseUrl && initializeIntercom(intercomAppId, appBaseUrl);
})();

